import React, { useEffect, useState, useRef } from 'react'
import Button from '@mui/material/Button';
import OtpInput from 'react-otp-input';
import { signup,sendOtp,verifyOtp } from '../../Redux/actions/customer';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

function OtpModal(props:any) {

    const {sendOtp,phone_number,email}=props;
    const [seconds, setSeconds] = useState<number>(90);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const [update, setUpdate] = useState(false);
    const { t, i18n } = useTranslation();

    const {otp,setOtp} = props

    const isArabic = i18n?.language?.startsWith('ar');

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);

        return () => {
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
            }
        };
    }, [update]);

    useEffect(() => {
        if (seconds === 0 && intervalRef.current !== null) {
            clearInterval(intervalRef.current);
        }
    }, [seconds]);

    let minutes=Math.floor(seconds / 60)
    let remainingSeconds=seconds % 60

    const handleResendOtp=()=>{
        sendOtp({ phone_number })
        setSeconds(90);
        setUpdate(!update);
    }

    return (
        <div>
            <h6 className='text-center font-normal'>
                {t("PLEASE_ENTER_THE_OTP_SENT_TO_YOUR")} {email ? (
                    <>email {email}</>
                ) : (
                    <>
                        {t("MOBILE_NUMBER")} {" "}
                        <span dir={isArabic ? 'ltr' : undefined} style={isArabic ? { direction: 'ltr', unicodeBidi: 'bidi-override' } : undefined}>
                            {phone_number}
                        </span>
                    </>
                )}
            </h6>
            <div className='otp-number mt-4'>
                <OtpInput
                    className='kfc-number-field'
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    inputMode="numeric"
                    pattern="[0-9]*" 
                    shouldAutoFocus={true}
                    inputType='number'
                    renderInput={(props) => <input {...props} />}
                />
                <h5 className='text-center font-normal mt-3'>
                    {minutes}:{remainingSeconds < 10 ? '0' : ''}
                    {remainingSeconds}
                </h5>
                <div className='d-flex justify-content-center align-items-center gap-10 mt-3'>
                    <h6 className='text-center font-normal'>{t("DID_NOT_RECEIVE_OTP")}</h6>
                    <h6 onClick={handleResendOtp} style={{cursor:"pointer"}} className='font-normal color-theme'>{t("RESEND")}</h6>
                </div>
              
            </div>

        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        sendOtp:function(data:any){
            dispatch(sendOtp(data))
        }
    }
  }
export default connect(null, mapDispatchToProps)(OtpModal);
